class AnnouncementBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.hasBeenDismissed) {
      this.setAttribute('aria-hidden', 'true')
      this.updateAnnouncementBarHeight()
      this.updateBodyPadding(false)
      return
    }

    this.updateAnnouncementBarHeight()

    if (!this.els?.slide?.exists) return

    this.desktopSpeed = Number(this.dataset.desktopSpeed) * 1000 || 30000
    this.mobileSpeed = Number(this.dataset.mobileSpeed) * 1000 || 30000

    this.desktopAnimationType = this.dataset.desktopAnimationType || 'opacity'
    this.mobileAnimationType = this.dataset.mobileAnimationType || 'slide'

    this.carousel = this.setupCarousel()
    this.updateBodyPadding(true)
  }

  setupListeners () {
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(window, 'resize', this.carouselSwitcher.bind(this))
    this.listeners.add(window, 'resize', this.updateAnnouncementBarHeight.bind(this))

    if (this.els.close) {
      this.listeners.add(this.els.close.element, 'click', this.handleClose)
    }
  }

  updateAnnouncementBarHeight () {
    const root = document.documentElement
    const announcementBarEl = document.getElementById('shopify-section-site-announcement-bar')
    const isTop = (this.dataset.position || 'top') === 'top'
    const isHidden = this.getAttribute('aria-hidden') === 'true'

    if (!announcementBarEl || !isTop || isHidden) {
      root.style.setProperty('--announcement-bar-height', '0px')
      return
    }

    root.style.setProperty('--announcement-bar-height', `${announcementBarEl.offsetHeight}px`)
  }

  updateBodyPadding (isVisible) {
    const root = document.documentElement
    const position = this.dataset.position || 'top'
    const padding = isVisible && position === 'bottom' ? '40px' : '0px'
    root.style.setProperty('--body-padding-bottom', padding)
  }

  handleClose () {
    this.markAsDismissed()
    document.activeElement.blur()
    this.setAttribute('aria-hidden', 'true')
    this.updateAnnouncementBarHeight()
    this.updateBodyPadding(false)
  }

  get sessionStorageKey () {
    return 'announcementBarDismissed'
  }

  get hasBeenDismissed () {
    return sessionStorage.getItem(this.sessionStorageKey) === 'true'
  }

  markAsDismissed () {
    sessionStorage.setItem(this.sessionStorageKey, 'true')
  }

  carouselSwitcher () {
    this.carousel.destroy()
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.els.slides.element.classList.add('keen-slider')
    this.els.slide.elements.forEach(el => el.classList.add('keen-slider__slide'))
    let pauseLength = 0

    if (window.innerWidth > 900) {
      if (this.desktopAnimationType === 'opacity') {
        this.speed = 1000
        pauseLength = 3
      } else {
        this.speed = this.desktopSpeed
      }
    } else {
      if (this.mobileAnimationType === 'opacity') {
        this.speed = 1000
        pauseLength = 3
      } else {
        this.speed = this.mobileSpeed
      }
    }

    const opacityOptions = {
      selector: this.els.slide.selector,
      loop: true,
      defaultAnimation: {
        duration: this.speed,
      },
      detailsChanged: (s) => {
        s.slides.forEach((element, idx) => {
          element.style.opacity = s.track.details.slides[idx].portion
          element.style.pointerEvents = idx === s.track.details.rel ? 'all' : 'none'
        })
      },
      renderMode: 'custom',
    }

    const slideOptions = {
      selector: this.els.slide.selector,
      loop: true,
      mode: 'snap',
      slides: {
        perView: 1,
        spacing: 0,
      },
      defaultAnimation: {
        duration: this.speed,
        easing: (t) => t,
      },
      detailsChanged: () => {}
    }

    let options = slideOptions

    if (window.innerWidth > 900) {
      if (this.desktopAnimationType === 'opacity') {
        options = opacityOptions
      }
    } else {
      if (this.mobileAnimationType === 'opacity') {
        options = opacityOptions
      }
    }

    return new window.KeenSlider(
      this.els.slides.element,
      options,
      [
        window.BAO.Carousel.plugins.useInitialised(),
        window.BAO.Carousel.plugins.useAutoplay(pauseLength),
      ]
    )
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
